import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { APP_ROUTES } from '../constants/approutes';

const BackButton = ({ 
  customBackPath, 
  customBackAction, 
  className = "",
  showText = true,
  text = "Back"
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (customBackAction) {
      customBackAction();
      return;
    }

    if (customBackPath) {
      navigate(customBackPath);
      return;
    }

    // Default back behavior - go to previous page or dashboard
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(APP_ROUTES.DASHBOARD);
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200 ${className}`}
      aria-label="Go back"
    >
      <ChevronLeft className="w-5 h-5" />
      {showText && <span className="font-bold">{text}</span>}
    </button>
  );
};

export default BackButton;
